<template>
  <div v-if="getBet.odds.length > 0">
    <div class="warning-odds-changed" v-if="warningOddsChanged">
      <span>{{ $t('updateOddsCart') }}</span>
    </div>
    <div v-if="showAlertLogin">
      <v-alert id="alertLogin" dense text type="error">
        {{ $t('alertlogin') }}
      </v-alert>
    </div>
    <div v-if="showAlertNotPlayable">
      <v-alert id="showAlertNotPlayable" dense text type="error">
        {{ $t('alertNotPlayable') }}
      </v-alert>
    </div>
    <div class="actions">
      <div class="cont_for_btn_book">
        <div
          :class="[
            'btn-book',
            (!getBet.check && getBet.errors.length > 0) ||
            checkToAcceptNewOdds() ||
            (getBet.context != 'prematch' && getBet.context != 'antepost')
              ? 'disabled'
              : '',
          ]"
          @click="bookingBet()"
        >
          {{ $t('bookBet') }}
        </div>
      </div>

      <div class="cont_for_btn_confirm">
        <div
          v-if="getAuthenticated && getCanPlay"
          :class="[
            'btn-confirm',
            (!getBet.check && getBet.errors.length > 0) ||
            checkToAcceptNewOdds() ||
            placing ||
            getIsCartUpdating === true
              ? 'disabled'
              : '',
          ]"
          @click="saveBet"
        >
          <v-icon
            x-small
            v-if="
              (!getBet.check && getBet.errors.length > 0) ||
              checkToAcceptNewOdds()
            "
          >
            mdi-block-helper
          </v-icon>
          {{ $t('placeBet') }}
        </div>
        <div
          v-else-if="!getAuthenticated && getCanPlay"
          class="btn-login-cart"
          @click="alertLogin()"
        >
          {{ $t('placeBet') }}
        </div>
        <div v-else class="btn-login-cart" @click="alertGeo()">
          {{ $t('placeBet') }}
        </div>
      </div>
    </div>

    <v-dialog
      v-if="!getModalIdle"
      transition="dialog-top-transition"
      :width="this.bookedCode == '' ? '724' : '600'"
      v-model="dialog"
      content-class="modal-on-top market-view-modal-confirmed-bet"
      persistent
    >
      <v-card class="text-center">
        <v-icon
          style="position: absolute; top: -36px; right: -36px"
          @click="closeModalDialogConfirm()"
          >mdi-close
        </v-icon>
        <div class="header-modal-confirmed-bet">
          <svg
            version="1.1"
            id="Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 120 120"
            style="enable-background: new 0 0 120 120"
            xml:space="preserve"
          >
            <g>
              <path
                d="M59.98,11.96c26.5,0,48.06,21.54,48.06,48.02c0,26.5-21.56,48.06-48.06,48.06c-26.47,0-48.01-21.56-48.01-48.06
		C11.96,33.5,33.5,11.96,59.98,11.96 M59.98,4C29.09,4,4,29.09,4,59.98C4,90.91,29.09,116,59.98,116C90.91,116,116,90.91,116,59.98
		C116,29.09,90.91,4,59.98,4L59.98,4z"
              />
              <path
                d="M95.08,39.74c-1.98-2.38-5.54-2.71-7.91-0.72L49.29,70.55L35.81,55.13c-0.99-1.13-2.36-1.81-3.85-1.91
		c-1.51-0.1-2.95,0.39-4.08,1.38c-2.33,2.04-2.57,5.6-0.53,7.93l17.09,19.56C45.5,83.3,47.04,84,48.67,84c1.31,0,2.59-0.46,3.59-1.3
		l42.1-35.05C96.74,45.67,97.06,42.12,95.08,39.74z"
              />
            </g>
          </svg>
          <span class="ml-2 text-uppercase">{{
            this.bookedCode == '' ? $t('betAccepted') : $t('betBooked')
          }}</span>
        </div>
        <div class="">
          <v-col
            cols="12"
            class="message-bet-success"
            v-if="this.bookedCode == ''"
          >
            <span class="text-uppercase" v-if="this.placedBet != ''">
              {{ this.placedBet }}
            </span>
            <btn
              v-if="this.placedBet != ''"
              @click="copyTextToClipboard(placedBet)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Livello_1"
                x="0px"
                y="0px"
                viewBox="0 0 120 120"
                style="enable-background: new 0 0 120 120"
                xml:space="preserve"
              >
                <path
                  d="M45.5,94.8c-3.2,0-5.9-1.1-8.2-3.4c-2.3-2.3-3.4-5-3.4-8.2V13.6c0-3.2,1.1-5.9,3.4-8.2c2.3-2.3,5-3.4,8.2-3.4h52.2  c3.2,0,5.9,1.1,8.2,3.4c2.3,2.3,3.4,5,3.4,8.2v69.6c0,3.2-1.1,5.9-3.4,8.2c-2.3,2.3-5,3.4-8.2,3.4H45.5z M45.5,83.2h52.2V13.6H45.5  V83.2z M22.3,118c-3.2,0-5.9-1.1-8.2-3.4s-3.4-5-3.4-8.2V31c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8v69.6  c0,3.2,2.6,5.8,5.8,5.8h52.2c3.2,0,5.8,2.6,5.8,5.8v0c0,3.2-2.6,5.8-5.8,5.8H22.3z M45.5,83.2V13.6V83.2z"
                />
                <rect class="st0" width="120" height="120" />
              </svg>
            </btn>
          </v-col>

          <v-col cols="12" class="message-bet-success" v-else>
            <span class="text-uppercase" v-if="this.bookedCode != ''">
              {{ this.bookedCode }}
            </span>
            <btn
              v-if="this.bookedCode != ''"
              @click="copyTextToClipboard(bookedCode)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Livello_1"
                x="0px"
                y="0px"
                viewBox="0 0 120 120"
                style="enable-background: new 0 0 120 120"
                xml:space="preserve"
              >
                <path
                  d="M45.5,94.8c-3.2,0-5.9-1.1-8.2-3.4c-2.3-2.3-3.4-5-3.4-8.2V13.6c0-3.2,1.1-5.9,3.4-8.2c2.3-2.3,5-3.4,8.2-3.4h52.2  c3.2,0,5.9,1.1,8.2,3.4c2.3,2.3,3.4,5,3.4,8.2v69.6c0,3.2-1.1,5.9-3.4,8.2c-2.3,2.3-5,3.4-8.2,3.4H45.5z M45.5,83.2h52.2V13.6H45.5  V83.2z M22.3,118c-3.2,0-5.9-1.1-8.2-3.4s-3.4-5-3.4-8.2V31c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8v69.6  c0,3.2,2.6,5.8,5.8,5.8h52.2c3.2,0,5.8,2.6,5.8,5.8v0c0,3.2-2.6,5.8-5.8,5.8H22.3z M45.5,83.2V13.6V83.2z"
                />
                <rect class="st0" width="120" height="120" />
              </svg>
            </btn>
          </v-col>

          <v-col cols="12" class="msg-success-bet-button">
            <v-btn
              elevation="2"
              class="print-btn"
              @click="print"
              v-if="this.bookedCode == ''"
            >
              <v-icon dark class="mr-2"> mdi-printer </v-icon>
              {{ $t('print') }}
            </v-btn>
            <v-btn elevation="2" class="newBet-btn" @click="clearCart">
              <v-icon dark class="mr-2"> mdi-file-outline </v-icon>
              {{ $t('newBet') }}
            </v-btn>
            <v-btn elevation="2" class="reloadBet-btn" @click="reloadBet">
              <v-icon dark class="mr-2"> mdi-reload </v-icon>
              {{ $t('reloadBet') }}
            </v-btn>
          </v-col>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="!getModalIdle"
      transition="dialog-top-transition"
      max-width="700"
      v-model="dialogError"
      content-class="modal-on-top market-view-modal-confirmed-bet"
      persistent
    >
      <v-card class="text-center">
        <v-icon
          style="position: absolute; top: -36px; right: -36px"
          @click="closeModalErrorDialog()"
          >mdi-close
        </v-icon>
        <div class="header-modal-confirmed-bet">
          <svg
            class="error_bet"
            data-v-d347e5f8=""
            version="1.1"
            id="Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 120 120"
            xml:space="preserve"
          >
            <g data-v-d347e5f8="">
              <path
                data-v-d347e5f8=""
                d="M60,4C29.12,4,4,29.12,4,60s25.12,56,56,56s56-25.12,56-56S90.88,4,60,4z M104.77,60c0,24.69-20.09,44.77-44.77,44.77
		S15.23,84.69,15.23,60S35.31,15.23,60,15.23S104.77,35.31,104.77,60z"
              ></path>
              <g data-v-d347e5f8="">
                <path
                  data-v-d347e5f8=""
                  d="M60,28.72c4.07,0,7.36,2.85,7.36,6.37v29.52c0,3.52-3.3,6.37-7.36,6.37s-7.36-2.85-7.36-6.37V35.09
			C52.64,31.57,55.93,28.72,60,28.72z"
                  class="st0"
                ></path>
                <path
                  data-v-d347e5f8=""
                  d="M67.37,83.91c0,4.07-3.3,7.38-7.37,7.38s-7.37-3.3-7.37-7.38s3.3-7.37,7.37-7.37S67.37,79.83,67.37,83.91z"
                ></path>
              </g>
            </g>
          </svg>
          <span class="ml-2 error_bet">{{ $t(error_code) }} </span>
        </div>
        <div>
          <v-col cols="12" class="message-bet-success">
            <span class="reason-mess">
              {{ this.formatMessage(error_reason) }}
            </span>
          </v-col>
        </div>
      </v-card>
    </v-dialog>

    <template>
      <v-snackbar v-model="snackbarCopy" vertical>
        <div class="text-subtitle-1 pb-2">{{ $t('info') }}</div>
        <p>{{ $t('codeCopiedToClipboard') }}</p>
        <template v-slot:actions>
          <v-btn color="indigo" variant="text" @click="snackbarCopy = false">
            {{ $t('close') }}
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '../../plugins/eventBus'

export default {
  name: 'Actions',
  data: () => ({
    dialog: false,
    dialogError: false,
    error_code: '',
    error_reason: 'n.d.',
    bookedCode: '',
    placedBet: '',
    showCopy: false,
    placing: false,
    showAlertLogin: false,
    showAlertNotPlayable: false,
    warningOddsChanged: false,
    print_electron: false,
    icarus: window.icarus,
    attemptsMade: 0,
    MAX_ATTEMPTS: 3,
    snackbarCopy: false,
  }),
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getAuthenticated: 'user/getAuthenticated',
      getLanguage: 'settings/getLanguage',
      getPlatformSettings: 'settings/getPlatformSettings',
      getOddsVariation: 'cart/getOddsVariation',
      getSettings: 'cart/getSettings',
      getType: 'user/getType',
      getId: 'user/getId',
      getCashier: 'user/getCashier',
      getElectron: 'settings/getElectron',
      getModalIdle: 'user/getModalIdle',
      getOddsType: 'odds/getOddsType',
      getShortCode: 'settings/getShortCode',
      getEnableClearCartAtPlaceBet: 'settings/getEnableClearCartAtPlaceBet',
      getIsCartUpdating: 'cart/getIsCartUpdating',
      isTerminalUser: 'user/isTerminalUser',
      getCanPlay: 'user/getCanPlay',
    }),
  },
  methods: {
    closeModalErrorDialog() {
      this.dialogError = false
      this.placedBet = ''
      this.bookedCode = ''
    },
    async copyCode(value) {
      try {
        await navigator.clipboard.writeText(value)
      } catch (e) {
        console.log(e)
      }
    },
    async copyTextToClipboard(text) {
      const vm = this
      this.snackbarCopy = true

      if (!navigator.clipboard) {
        //console.log('Navigator clipboard not supported, using fallback.');
        this.fallbackCopyTextToClipboard(text)
        return
      }

      try {
        await navigator.clipboard.writeText(text)
        //console.log('Text copied to clipboard');
      } catch (err) {
        console.error('Failed to copy text: ', err)
        this.snackbarCopy = false
        this.fallbackCopyTextToClipboard(text) // Fallback in case of error
      }

      setTimeout(() => (vm.snackbarCopy = false), 3000)
    },

    fallbackCopyTextToClipboard(text) {
      const shadowHost = document.createElement('div')
      const shadowRoot = shadowHost.attachShadow({ mode: 'closed' })

      const textArea = document.createElement('textarea')
      textArea.value = text

      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      textArea.style.pointerEvents = 'none'

      shadowRoot.appendChild(textArea)
      document.body.appendChild(shadowHost)

      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        //console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
        this.snackbarCopy = false
      }

      document.body.removeChild(shadowHost)
    },

    ...mapActions({
      resetCart: 'cart/resetCart',
      removeOddFromCart: 'cart/removeOddFromCart',
      refreshCart: 'cart/refreshCart',
      placeBet: 'cart/placeBet',
      bookBet: 'cart/bookBet',
      replaceOdds: 'cart/replaceOdds',
      acceptAllOdds: 'cart/acceptAllOdds',
      acceptOdd: 'cart/acceptOdd',
      setLoadingCart: 'cart/setLoadingCart',
      addBetInAcceptance: 'cart/addBetInAcceptance',
    }),

    formatMessage(msg) {
      return unescape(msg)
    },
    async saveBet() {
      const vue = this
      vue.placedBet = ''
      vue.bookedCode = ''

      if (vue.placing || vue.getIsCartUpdating === true) {
        return
      }

      await vue.setLoadingCart({ status: true })
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      if (
        (!vue.getBet.check && vue.getBet.errors.length > 0) ||
        vue.checkToAcceptNewOdds() ||
        vue.placing
      ) {
        await vue.setLoadingCart({ status: false })
        vue.placing = false
        return
      } else {
        vue.placing = true

        const response = await this.placeBet({
          betContext: vue.getBet.context,
          lang: vue.getLanguage,
          accept_odds: vue.getOddsVariation,
        })

        if (response.result == true) {
          vue.attemptsMade = 0
          vue.placedBet =
            vue.getShortCode == true ? response.shortCode : response.bet_code
          if (
            vue.getElectron &&
            vue.getSettings.enableDirectPrintAgency &&
            (vue.getType == 4 || (vue.getType == 2 && vue.getCashier))
          ) {
            this.print_electron = true
            this.print()
            this.clearCart()
            vue.warningOddsChanged = false
            vue.dialogError = false
            vue.placing = false
            await vue.setLoadingCart({ status: false })
          } else if (this.isTerminalUser === true) {
            vue.printForTerminal()
            vue.clearCart()

            vue.warningOddsChanged = false
            vue.dialogError = false
            vue.placing = false
            await vue.setLoadingCart({ status: false })
          } else {
            vue.warningOddsChanged = false
            vue.dialog = true
            vue.dialogError = false
            vue.placing = false
            await vue.setLoadingCart({ status: false })
          }
        } else {
          vue.placing = false
          await vue.setLoadingCart({ status: false })
          switch (response.error_code) {
            case 'update_odds':
              if (vue.getOddsVariation) {
                vue.warningOddsChanged = true
                await vue.replaceOdds({ odds: response.data_to_update })
                await vue.acceptAllOdds()
                await this.$root.$emit('forceUpdateOddsSummary')
                await vue.refreshCart()
                const check_disabled = _.find(response.data_to_update, {
                  reason: 'disabled',
                })
                const check_time_over = _.find(response.data_to_update, {
                  reason: 'time_over',
                })
                if (!check_time_over && !check_disabled) {
                  vue.attemptsMade = vue.attemptsMade + 1
                  if (vue.attemptsMade <= vue.MAX_ATTEMPTS) {
                    await this.saveBet()
                  }
                }
              } else {
                await vue.replaceOdds({ odds: response.data_to_update })
                await this.$root.$emit('forceUpdateOddsSummary')
              }
              break
            case 'totals_incorrect':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_check':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_repetition':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('vincols_repetitions')
              break
            case 'external_save_failed':
              vue.dialogError = true
              if (response.reason === 'Errore range di quote non rispettate') {
                vue.error_code = vue.$t('limitExceed')
              } else if (response.reason === 'reject by Ai') {
                vue.error_code = vue.$t('bet_not_accepted')
                vue.error_reason = vue.$t('rejectedByAi')
              } else {
                vue.error_code = vue.$t('bet_not_accepted')
                vue.error_reason = response.reason || vue.$t('pleaseTryAgain')
              }
              break
            case 'review':
              vue.dialogError = true
              vue.error_code = vue.$t('betReview')
              vue.error_reason = vue.$t('betUnderReview')
              vue.addBetInAcceptance({ code: response.result })
              break
            case 'event_not_avaiable':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('oddNotAvailableInCart')
              break
            case 'user_locked':
              vue.dialogError = true
              vue.error_code = vue.$t('user_locked')
              vue.error_reason = vue.$t('errors.user_locked_text')
              break
            case 'agency_locked':
              vue.dialogError = true
              vue.error_code = vue.$t('agency_locked')
              vue.error_reason = vue.$t('agency_locked')
              break
            case 'MAX_CURRENT_WEEK_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_WEEK_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_DAY_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_DAY_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'user_profile_forbidden':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.userProfileNotEnabled')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'INVALID_CURRENCY':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'reject_bet_time_live_odd_expired':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('marketClosedPleaseTryAgain')
              break
            case 'user_staged':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('errors.user_staged_text')
              break
            default:
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
          }
        }
      }
    },

    async bookingBet() {
      const vue = this

      if (
        (vue.getBet.context !== 'prematch' &&
          vue.getBet.context !== 'antepost') ||
        vue.getIsCartUpdating === true
      ) {
        return
      }

      vue.showCopy = false
      await vue.setLoadingCart({ status: true })
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      if (
        (!vue.getBet.check && vue.getBet.errors.length > 0) ||
        vue.checkToAcceptNewOdds()
      ) {
        await vue.setLoadingCart({ status: false })
        return
      } else {
        const response = await this.bookBet({
          betContext: vue.getBet.context,
          lang: vue.getLanguage,
        })
        if (response.result == true) {
          vue.bookedCode = response.bet_code
          vue.dialog = true
          vue.dialogError = false
          await vue.setLoadingCart({ status: false })
          vue.attemptsMade = 0
        } else {
          await vue.setLoadingCart({ status: false })
          switch (response.error_code) {
            case 'update_odds':
              if (vue.getOddsVariation) {
                await vue.replaceOdds({ odds: response.data_to_update })
                await vue.acceptAllOdds()
                await this.$root.$emit('forceUpdateOddsSummary')
                await vue.refreshCart()
                if (vue.attemptsMade < vue.MAX_ATTEMPTS) {
                  await this.bookingBet()
                }
              } else {
                await vue.replaceOdds({ odds: response.data_to_update })
                await this.$root.$emit('forceUpdateOddsSummary')
              }
              break
            case 'totals_incorrect':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_check':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'external_save_failed':
              vue.dialogError = true
              if (response.reason === 'Errore range di quote non rispettate') {
                vue.error_code = vue.$t('limitExceed')
              } else if (response.reason === 'reject by Ai') {
                vue.error_code = vue.$t('bet_not_accepted')
                vue.error_reason = vue.$t('rejectedByAi')
              } else {
                vue.error_code = vue.$t('bet_not_accepted')
                vue.error_reason = response.reason || vue.$t('pleaseTryAgain')
              }
              break
            case 'cant_book_live_odds':
              vue.dialogError = true
              vue.error_code = vue.$t('cant_book_live_odds')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_WEEK_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_WEEK_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_DAY_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_DAY_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'INVALID_CURRENCY':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'reject_bet_time_live_odd_expired':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('marketClosedPleaseTryAgain')
              break
            case 'user_staged':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('errors.user_staged_text')
              break
            default:
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
          }
        }
      }
    },

    async clearCart() {
      this.showCopy = false
      this.dialog = false
      this.dialogError = false
      this.warningOddsChanged = false
      this.showAlertLogin = false
      this.showAlertNotPlayable = false
      this.$root.$emit('cart_handling', true)
      await this.resetCart()
    },

    async alertGeo() {
      if (!this.getCanPlay) {
        this.showAlertNotPlayable = true
      }
    },
    async alertLogin() {
      if (!this.getAuthenticated) {
        this.showAlertLogin = true
      }
    },
    print() {
      if (this.icarus) {
        IcarusInterface.printTicketRocky(this.placedBet.toString())
        this.dialog = false
      } else {
        if (this.print_electron) {
          window.open(
            this.getPlatformSettings.print_endpoint +
              this.placedBet +
              '&electron=1',
            '_blank',
            'height=600,width=350'
          )
        } else {
          if (this.getShortCode) {
            window.open(
              this.getPlatformSettings.print_endpoint +
                this.placedBet +
                '&login=' +
                this.getType +
                '&ancestors=' +
                this.getId +
                '&type_odd=' +
                this.getOddsType,
              '_blank',
              'height=600,width=350'
            )
          } else {
            window.open(
              this.getPlatformSettings.print_endpoint +
                this.placedBet +
                '&type_odd=' +
                this.getOddsType,
              '_blank',
              'height=600,width=350'
            )
          }
        }
        this.dialog = false
      }

      this.showCopy = false
      this.dialogError = false
    },
    printForTerminal() {
      if (this.getShortCode) {
        window.open(
          this.getPlatformSettings.print_endpoint +
            this.placedBet +
            '&login=' +
            this.getType +
            '&ancestors=' +
            this.getId +
            '&type_odd=' +
            this.getOddsType +
            '&autoPrint=true',
          '_blank',
          'height=600,width=350'
        )
      } else {
        window.open(
          this.getPlatformSettings.print_endpoint +
            this.placedBet +
            '&type_odd=' +
            this.getOddsType +
            '&autoPrint=true',
          '_blank',
          'height=600,width=350'
        )
      }
      this.dialog = false
      this.showCopy = false
      this.dialogError = false
    },
    printBet(bet) {
      const codeBet = this.getShortCode == true ? bet.betCode : bet.code

      if (this.getShortCode) {
        window.open(
          this.getPlatformSettings.print_endpoint +
            codeBet +
            '&login=' +
            this.getType +
            '&ancestors=' +
            this.getId +
            '&type_odd=' +
            this.getOddsType,
          '_blank',
          'height=600,width=350'
        )
      } else {
        window.open(
          this.getPlatformSettings.print_endpoint +
            codeBet +
            '&type_odd=' +
            this.getOddsType,
          '_blank',
          'height=600,width=350'
        )
      }
      this.dialog = false
    },

    reloadBet() {
      this.showCopy = false
      this.dialog = false
      this.dialogError = false
    },

    checkToAcceptNewOdds() {
      const vue = this
      const changed = _.filter(vue.getBet.odds, function (odd) {
        return odd.changed
      })

      return changed.length > 0
    },

    handleCopyStatus(status) {
      this.copySucceeded = status
    },

    async closeModalDialogConfirm() {
      const vm = this
      this.dialog = false
      this.placedBet = ''
      this.bookedCode = ''

      if (vm.getEnableClearCartAtPlaceBet === true) {
        vm.$root.$emit('cart_handling', true)
        await vm.resetCart()
      }
    },

    closeModalReserveAlert() {
      if (this.error_code == this.$t('betReview')) {
        this.dialogError = false
      }
    },
    cleanCartAction() {
      const vm = this
      if (vm.getEnableClearCartAtPlaceBet === true) {
        vm.clearCart()
      }
    },
  },
  mounted() {
    const vm = this
    this.$root.$on('print_this_bet', function (bet) {
      vm.printBet(bet)
    })
    EventBus.$on('closeModalReserveAlert', vm.closeModalReserveAlert)
    EventBus.$on('cleanTheCart', vm.cleanCartAction)
  },
  beforeDestroy() {
    const vm = this
    this.$root.$off('print_this_bet', vm.printBet)

    EventBus.$off('closeModalReserveAlert', vm.closeModalReserveAlert)
    EventBus.$off('cleanTheCart', vm.cleanCartAction)
  },
}
</script>
